import { T, useI18n } from '@tribeplatform/react-components/i18n'
import {
  SystemSpaceSlug,
  useAuthToken,
  useSpaceUtil,
} from '@tribeplatform/react-sdk/hooks'
import { Alert } from '@tribeplatform/react-ui-kit/Alert'

import { isAdminEmailNotConfirmed } from './utils'

export const EmailVerificationBanner = () => {
  const { $t } = useI18n()
  const { data: authToken } = useAuthToken()
  const { generatePath } = useSpaceUtil()

  if (!isAdminEmailNotConfirmed(authToken.member)) {
    return null
  }

  return (
    <Alert
      status="info"
      title={$t({
        defaultMessage: 'Admin email address is not verified',
        id: 'UserImport.Alert.AdminNotVerified',
      })}
    >
      <T
        defaultMessage="Please <confirmation>confirm your email address</confirmation> to invite {MEMBERS}"
        id="UserImport.Alert.AdminNotVerified.CTA"
        values={{
          confirmation: chunks => (
            <a
              className="underline"
              href={generatePath(SystemSpaceSlug.VERIFY_EMAIL, null, {
                memberId: authToken.member?.id,
                resend: 'true',
              })}
            >
              {chunks}
            </a>
          ),
        }}
      />
    </Alert>
  )
}
